<template>
  <div class="receive">
    <div v-if="info">
      <div class="status-content">
        <div class="item success1" v-if="status == '已领取'">
          <div class="item-top">
            <span>已领取</span>
          </div>
          <div class="time" v-if="info.created_at"
            >于{{ info.created_at | filterTime }}成功领取</div
          >
        </div>
        <div class="item success" v-else>
          <div class="item-top">
            <span class="iconfont icon-gou"></span><span>领取成功</span>
          </div>
        </div>
      </div>
      <!--  -->
      <div class="prize-content">
        <div class="prize-list">
          <div
            class="prize-item"
            v-for="(item, index) in info.invited_prize_list"
            :key="index"
          >
            <span class="prize-name">{{ item.prize_name }}</span>
            <span>x 1</span>
          </div>
        </div>
        <div class="btn">
          <span>来自</span>
          <img class="avatar" :src="info.head_img" alt="" />
          <span>{{ info.truename }}</span>
          <span>的赠送</span>
        </div>
        <img class="tips" v-if="info.lead_text" :src="info.lead_text" alt="" />
      </div>
      <div
        class="download-btn"
        v-if="$route.query.activityType != 2"
        @click="bindDownload"
        >{{ info.receive_button || '下载APP使用礼包' }}</div
      >
      <!-- 客服 -->
      <div class="service-content">
        <div class="tip" v-if="info.assistant_copywriter">{{
          info.assistant_copywriter
        }}</div>
        <img class="qrcode" :src="info.assistant_code" alt="" />
        <div class="text">长按添加助教</div>
      </div>
    </div>
    <van-loading
      class="v-loading"
      v-if="!loaded"
      text-color="#999"
      color="#999"
      vertical
      >加载中...</van-loading
    >
  </div>
</template>
<script>
export default {
  data() {
    return {
      loaded: false,
      status: '已领取',
      info: null
    }
  },
  filters: {
    filterTime(str) {
      if (!str) {
        return ''
      }
      let res = ''
      str = str.replace(/-/g, '/')
      let cTime = new Date(str)
      let hours = cTime.getHours()
      let min = cTime.getMinutes()
      hours = hours < 10 ? '0' + hours : hours
      min = min < 10 ? '0' + min : min
      res =
        cTime.getFullYear() +
        '年' +
        (cTime.getMonth() + 1) +
        '月' +
        cTime.getDate() +
        '日' +
        ' ' +
        hours +
        ':' +
        min +
        '分'
      return res
    }
  },
  created() {
    this.getParams()
    this.getData()
  },
  methods: {
    bindDownload() {
      location.href = 'https://member3.gymcity.com.cn/#/app-download'
    },
    getParams() {
      this.status = this.$route.query.status
    },
    getData() {
      let params = {
        activity_id: this.$route.query.activityId,
        pid: this.$route.query.pid,
        cid: this.$route.query.cid
      }
      this.$http
        .getBaseApp('member/ActivitySys/getReceivePrize', params)
        .then((res) => {
          res = res.data
          if (res.code === 200) {
            res.data.tips =
              "<span>登录betterWE APP，在 </span><span class='blue'>我的 - 我的问卷，</span><span>即可提交个人问卷，获取身体评估报告，营养师将为您定制饮食方案</span>"
            res.data.coachTips =
              '请添加您的专属助教，免费体验￥199元的真人营养师1日服务，限量200份；后续有任何疑问，可随时联系您的助教为您解答哦~'
            this.info = res.data
          } else {
            this.$toast(res.msg)
          }
        })
        .catch(() => {})
        .finally(() => {
          this.loaded = true
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.receive {
  min-height: 100vh;
  overflow: hidden;
  padding: 0px 20px;
  box-sizing: border-box;
  background: #f9f9f9;
  .status-content {
    .success {
      padding: 50px 0px 30px;
    }
    .success1 {
      padding: 50px 0px 18px;
    }
    .item {
      text-align: center;
    }
    .item-top {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: #000000;
      line-height: 28px;
    }
    .time {
      margin-top: 3px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #000000;
      line-height: 17px;
    }
    .iconfont {
      margin-right: 10px;
      width: 24px;
      height: 24px;
      background: #6236ff;
      border-radius: 50%;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
    }
  }
  .prize-content {
    background: #ffffff;
    border-radius: 12px;
    padding: 8px 24px 17px;
    box-sizing: border-box;
    margin-bottom: 26px;
    .prize-list {
      .prize-item {
        display: flex;
        align-items: center;
        padding: 10px 0px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: rgba(0, 0, 0, 0.5);
        line-height: 17px;
        border-bottom: 1px dashed #e8e8e8;
        .prize-name {
          flex: 1;
          flex-shrink: 0;
          overflow: hidden;
          white-space: normal;
          text-overflow: ellipsis;
          margin-right: 20px;
        }
      }
      .prize-item:last-child {
        border-bottom: none;
      }
    }
    .btn {
      margin-top: 6px;
      height: 31px;
      background: #f7f7f7;
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: rgba(0, 0, 0, 0.5);
      .avatar {
        width: 16px;
        height: 16px;
        border-radius: 4px;
        overflow: hidden;
        margin: 0px 5px;
      }
    }
  }
  .tips {
    width: 100%;
    margin-top: 16px;
    .blue {
      color: #6236ff;
    }
  }
  .download-btn {
    margin: 0 auto;
    width: 315px;
    height: 44px;
    text-align: center;
    background: #6236ff;
    border-radius: 12px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    line-height: 44px;
  }
  .service-content {
    padding: 32px 23px;
    box-sizing: border-box;
    background: #ffffff;
    border-radius: 12px;
    margin-top: 27px;
    margin-bottom: 127px;
    .tip {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #000000;
      line-height: 24px;
      margin-bottom: 21px;
    }
    .qrcode {
      margin: 0 auto;
      width: 190px;
      height: 190px;
      object-fit: contain;
      margin-bottom: 9px;
    }
    .text {
      text-align: center;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.5);
      line-height: 17px;
    }
  }
}
.v-loading {
  position: fixed;
  left: 50%;
  top: 30%;
  transform: translate(-50%, 0%);
  z-index: 1;
}
</style>
